// La API de encabezados usa esta imagen cuando el producto no tiene miniatura.
export const esPublicacionSinImagen = (publicacion) => {
    const imagenes = publicacion?.imagenes ?? publicacion?.Imagenes;
    const imagen = Array.isArray(imagenes) ? imagenes[0] : publicacion?.imagen;
    const url = typeof imagen === 'string' ? imagen : imagen?.urlImagen ?? imagen?.UrlImagen;
    return !url?.trim() || /\/EnProceso_zoom2x\.png(?:[?#]|$)/i.test(url);
};

export const obtenerElementosPublicaciones = (response) =>
    response?.content ?? response?.Content ?? response?.elementos ?? response?.Elementos ?? [];

// Recorrer todas las páginas antes de filtrar conserva los totales y permite
// reprocesar toda la búsqueda, incluso publicaciones fuera de la página visible.
export const buscarPublicacionesSinImagen = async (fetchPage, params) => {
    const { sinImagen, pagina, Pagina, recordsPorPagina, RecordsPorPagina, ...filtros } = params;
    const publicaciones = new Map();
    let paginas = 1;
    for (let page = 1; page <= paginas; page += 1) {
        const response = await fetchPage({ ...filtros, pagina: page, recordsPorPagina: 50 });
        const elementos = obtenerElementosPublicaciones(response);
        if (page === 1) {
            const total = Number(response?.total ?? response?.Total ?? response?.cantidadTotal ?? 0);
            paginas = Number(response?.totalPages ?? response?.TotalPages ?? response?.cantidadPagina)
                || Math.ceil(total / (Number(response?.pageSize ?? response?.PageSize) || elementos.length || 50)) || 1;
        }
        if (!elementos.length && page < paginas) {
            throw new Error('La búsqueda cambió mientras se consultaban las publicaciones. Volvé a buscar.');
        }
        elementos.filter(esPublicacionSinImagen).forEach(publicacion => {
            const id = Number(publicacion.idPublicacion ?? publicacion.IdPublicacion);
            if (!Number.isInteger(id) || id <= 0) throw new Error('Publicación sin ID válido.');
            publicaciones.set(id, { ...publicacion, idPublicacion: id });
        });
    }
    return [...publicaciones.values()];
};

const estadoPublicacion = (publicacion) => String(publicacion.estado ?? publicacion.Estado ?? '').toLowerCase();

export const paginarPublicacionesSinImagen = (elementos, pagina = 1) => ({
    content: elementos.slice((pagina - 1) * 10, pagina * 10),
    total: elementos.length,
    totalPages: Math.ceil(elementos.length / 10),
    page: pagina,
    activos: elementos.filter(p => ['activo', '1'].includes(estadoPublicacion(p))).length,
    enRevision: elementos.filter(p => ['en_revision', '4'].includes(estadoPublicacion(p))).length,
    conStockNoPublicados: elementos.filter(p => Number(p.stock ?? p.Stock) > 0
        && !['activo', '1'].includes(estadoPublicacion(p))).length
});
